<script setup>
const props = defineProps({
  class: { type: String, required: false },
});
</script>

<template>
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="justify-self-end self-center fill-current row-start-1 col-start-1 pointer-events-none max-w-[13px]"
    :class="props.class"
  >
    <path
      d="M7.15691 17.7071C7.54743 18.0976 8.1806 18.0976 8.57112 17.7071L14.9351 11.3431C15.3256 10.9526 15.3256 10.3195 14.9351 9.92893C14.5446 9.53841 13.9114 9.53841 13.5209 9.92893L7.86401 15.5858L2.20716 9.92893C1.81664 9.53841 1.18347 9.53841 0.792946 9.92893C0.402422 10.3195 0.402422 10.9526 0.792946 11.3431L7.15691 17.7071ZM6.86401 4.37114e-08L6.86401 17L8.86401 17L8.86401 -4.37114e-08L6.86401 4.37114e-08Z"
    />
  </svg>
</template>

<style scoped></style>
